<template>
  <el-table-column
    prop="updated_at"
    sortable="custom"
    label="Módosítva"
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.updated_at | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'updated_at',
};
</script>
